var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5434 9.13251C17.6332 10.0517 13.2019 14.5275 12.2141 15.5251C11.587 16.1584 10.5703 16.1582 9.94335 15.5251C9.31627 14.8917 9.31627 13.8649 9.94335 13.2317L13.5179 9.62159H1.60562C0.718835 9.62159 0 8.89559 0 7.99997C0 7.10436 0.718835 6.37836 1.60562 6.37836H13.5179L9.94343 2.76833C9.31635 2.13501 9.31635 1.1082 9.94343 0.47496C10.5705 -0.15828 11.5872 -0.158361 12.2142 0.47496C13.0871 1.35663 17.688 6.00353 18.542 6.86606C19.1553 7.50027 19.1496 8.50567 18.5434 9.13251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9109e4fbbf98857a7b754b3010dd6782.svg";
export { ForwardRef as ReactComponent };